
<div class="help-section" (click)="redirect()" style="cursor: pointer;">
    <div class="section-container">
        <div class="shadow-1"></div>
        <div class="shadow-2"></div>
        <div class="section-content">
            <div>
                <div class="title">{{ 'events.reforestaction.help.title' | translate }}</div>
                <div class="details-label">{{ 'events.reforestaction.help.details' | translate }}</div>

                <button class="btn-primary" style="margin-top: 1em; z-index: 999;">{{ 'events.reforestaction.start-on-kinomap' | translate }}</button>
            </div>
        </div>
        <div class="devices" #devices *ngIf="responsiveScreenService.isOrBigger('HD')">
            <img src="assets/images/reforestaction/devices_logo.webp" />
        </div>
    </div>
</div>
